import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { monthNames } from '../../constants.ts';
import SummaryCard from '../../components/SummaryCard/SummaryCard.tsx';
interface SummaryDashboardProps {
  totalRawPropsFoundToday: number;
  totalRawPropsFoundLast30days: number;
  totalFoundToday: number;
  totalFoundLast30days: number;
  totalDeals: number;
  emailsSent: number;
}


const SummaryDashboard = ({totalRawPropsFoundToday, totalRawPropsFoundLast30days, totalDeals, emailsSent, totalFoundLast30days, totalFoundToday}: SummaryDashboardProps) => {

  const currentMonthName = monthNames[new Date().getMonth()];

  return (
    <Box sx={{ flexGrow: 1, p: 3 }} display="flex" alignItems="center" justifyContent='center' flexDirection={'column'}>
      <Typography variant="h4" gutterBottom>
        Summary Dashboard
      </Typography>
      <Grid container spacing={3} mt={2}>
        <SummaryCard stat={totalFoundToday || 0} statName={`Total Deals Found in ${currentMonthName}`} Icon={AttachMoneyIcon} />
        <SummaryCard stat={totalFoundLast30days || 0} statName="Total Deals Found Today" Icon={AttachMoneyIcon} />
        <SummaryCard stat={emailsSent || 0} statName="Total Emails Found Today" Icon={EmailIcon} />
        <SummaryCard stat={emailsSent || 0} statName={`Total Emails Found in ${currentMonthName}`} Icon={EmailIcon} />
        <SummaryCard stat={totalRawPropsFoundLast30days || 0} statName={`Total Properties Found In The Last 30 days`} Icon={HomeIcon} />
        <SummaryCard stat={totalRawPropsFoundToday || 0} statName={`Total Properties Found Today`} Icon={HomeIcon} />
      </Grid>
    </Box>
  );
};

export default SummaryDashboard;